import React from 'react';

import { componentService } from '@core/js/services/component.service';

export const ListAnchorNavigation = React.lazy(() => import('./ListAnchorNavigation'));

componentService.registerWebContentComponents({ ListAnchorNavigation });
